import asyncComponent from '../common/utils/async-component.js';

const CdnSettings = asyncComponent(() => import('./components/cdn-settings/index.js'));

export default {
  '/cdn': {
    components: { main: CdnSettings }
  }
};
